import React, { useContext } from 'react';
import classnames from 'classnames';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import BiSpan from '@wix/da-bi/pkg/Components/BiSpan';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './Button.scss';
const Button = ({ id, name, type = 'button', disabled, href, isFakeButton, onClick, onMouseEnter, onMouseLeave, value, children, 'data-role': dataRole, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-hidden': ariaHidden, 'aria-disabled': ariaDisabled, 'aria-details': ariaDetails, biData, tabIndex, innerRef, target, rel, download, view = 'b1-1', withPaddings, height, className, forceHoverStateWhenDisabledBecauseReasons, fullWidth, minWidth })=>{
    const isMobile = useContext(MobileContext);
    const renderRealButton = ()=>/*#__PURE__*/ React.createElement(BiButton, {
            id: id,
            name: name,
            type: type,
            disabled: disabled,
            className: getClassNames(),
            style: getInlineStyles(),
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            "aria-hidden": ariaHidden,
            "aria-disabled": ariaDisabled,
            "aria-details": ariaDetails,
            "data-role": dataRole,
            value: value,
            biData: biData,
            tabIndex: tabIndex,
            innerRef: innerRef
        }, children);
    const renderLinkButton = ()=>/*#__PURE__*/ React.createElement(BiLink, {
            id: id,
            href: href,
            className: getClassNames(),
            style: getInlineStyles(),
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            "aria-hidden": ariaHidden,
            "aria-disabled": ariaDisabled,
            "aria-details": ariaDetails,
            "data-role": dataRole,
            target: target,
            rel: rel,
            biData: biData,
            tabIndex: tabIndex,
            download: download
        }, children);
    const renderFakeButton = ()=>/*#__PURE__*/ React.createElement(BiSpan, {
            id: id,
            className: getClassNames(),
            style: getInlineStyles(),
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            "aria-hidden": ariaHidden,
            "aria-disabled": ariaDisabled,
            "aria-details": ariaDetails,
            "data-role": dataRole,
            biData: biData,
            role: "button"
        }, children);
    const getClassNames = ()=>classnames(s['button'], view && s[view], isFullWidth() && s['full-width'], disabled && s['disabled'], withPaddings && s['with-paddings'], height && s[`height-${height}`], forceHoverStateWhenDisabledBecauseReasons && disabled && s['force-hover-state'], className);
    const getInlineStyles = ()=>{
        const styles = {};
        if (minWidth) {
            styles.minWidth = minWidth;
        }
        return styles;
    };
    const isFullWidth = ()=>fullWidth !== undefined ? fullWidth : isMobile && !minWidth;
    if (isFakeButton) {
        return renderFakeButton();
    }
    return href ? renderLinkButton() : renderRealButton();
};
Button.displayName = 'Button';
export default Button;

//# sourceMappingURL=Button.js.map